export enum AdminUiMenuItemType {
  Page = 'page',
  ContentGroup = 'contentGroup',
  MenuEditor = 'menuEditor',
  Settings = 'settings',
  RedirectPolicies = 'redirectPolicyEditor',
}
export enum AdminUiPageType {
  Content = 'content',
  Marketing = 'marketing',
  Redeem = 'redeem',
  Genre = 'genre',
}
export enum AdminUiMenuItemActionIconType {
  Streaming = 'streaming',
  Linear = 'linear',
}
export enum AdminUiSubMenuItemType {
  App = 'app',
  Brand = 'brand',
  Channel = 'channel',
  TenantConfig = 'tenantConfig',
}
export interface AdminUiPageActions {
  isPageViewIconEnabled: boolean;
  isPlatformEnabled: boolean;
  isUserSegmentEnabled: boolean;
  isForcePublishEnabled: boolean;
}
export interface AdminUiPage {
  name: string;
  type: AdminUiPageType;
  order: number;
  url: string;
  actions: AdminUiPageActions;
}

export enum AdminUiContentGroupType {
  OsnPlus = 'OSNPlus',
}

export interface AdminUiContentGroupAction {
  isDesignatedContentGroupEnabled: boolean;
}

export interface AdminUiContentGroup {
  name: string;
  type: AdminUiContentGroupType;
  order: number;
  url: string;
  actions: AdminUiContentGroupAction;
}
export enum ProfileType {
  Kids = 'KIDS',
  Adult = 'ADULT',
  Default = 'DEFAULT',
}

export interface AdminUiMenuItemAction {
  isPlatformEnabled?: boolean;
  iconType?: AdminUiMenuItemActionIconType;
  isMenuTypeEnabled?: boolean;
}

export interface AdminUiSubMenuItem {
  name: string;
  type: AdminUiSubMenuItemType;
  order: number;
  url?: string;
}

export interface AdminUiMenuItem {
  name: string;
  type: AdminUiMenuItemType;
  order: number;
  url?: string;
  pageTypes?: Array<AdminUiPage>;
  contentGroupTypes?: Array<AdminUiContentGroup>;
  defaultPlatformId?: string;
  defaultProfileType?: ProfileType;
  availableProfileTypes?: Array<ProfileType>;
  actions?: AdminUiMenuItemAction;
  subMenuItems?: Array<AdminUiSubMenuItem>;
}

export interface AdminUiDetails {
  menuItems: Array<AdminUiMenuItem>;
}

export interface GroupedAdminUiPageActions {
  content: AdminUiPageActions;
  marketing: AdminUiPageActions;
  redeem: AdminUiPageActions;
  genre: AdminUiPageActions;
}

export interface GroupedAdminUiPageTypes {
  content?: AdminUiPage;
  marketing?: AdminUiPage;
  redeem?: AdminUiPage;
  genre?: AdminUiPage;
}
